// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__3Ek0R","loading":"Loading_loading__MGID9"};